<template>
    <div class="weather-wampper">
        <!-- <iframe 
            v-if="setNum == '1' && !axiosTrue"
            src="https://tianqiapi.com/api.php?style=tw&skin=pitaya" 
            frameborder="0" 
            width="550" 
            height="250" 
            color="FFFFFF" 
            style="background:rgba(255, 255, 255, 0.8)" 
            allowtransparency="true">
        </iframe> -->
        <div class="day-list" v-if="setNum == '1' && axiosTrue && weatherSlot=='now'"> 
            <div class="day-child" v-for="(item,index) in weatherList" :key="index">
                <p class="list-date">{{item.week | filterWeek(index) }}<br/>{{item.days | filterDays}}</p>
                <p class="list-weather f0B79F0">
                    {{item.weather | filterWeather}}<br/>
                    <img :src="item.weather_icon | filterWeather_icon" alt="">
                    <!-- <span class="bgIcon-weather" :class="'bg'+item.weatid"></span> -->
                </p>
                <p class="list-T">{{item.temp_high}}℃</p>
                <p class="list-T">{{item.temp_low}}℃</p>
                <p class="list-wind">{{item.windid | filterWind}}<br/>{{item.winp | filterWeather}}</p>
            </div> 
        </div>
        <div class="day-list" v-if="setNum == '1' && axiosTrue && weatherSlot=='history'"> 
            <div class="day-child" v-for="(item,index) in weatherListHistory" :key="index">
                <p class="list-date">{{item.time | filterHistoryWeek(index) }}<br/>{{item.time | filterHistoryDays}}</p>
                <p class="list-weather f0B79F0">
                    {{item.wtNm}}<br/>
                    <img :src="item.wtIcon | filterHistoryWeather_icon" alt="">
                    <!-- <span class="bgIcon-weather" :class="'bg'+item.weatid"></span> -->
                </p>
                <p class="list-T">{{item.wtTempMax}}℃</p>
                <p class="list-T">{{item.wtTempMin}}℃</p>
                <p class="list-wind">{{item.wtWindNm}}<br/>{{item.wtWinp}}级</p>
            </div> 
        </div>
        <!-- <iframe
            v-if="setNum == '2' && !axiosTrue"
            scrolling="no"
            src="https://tianqiapi.com/api.php?style=tl&skin=pitaya"
            frameborder="0"
            width="90%"
            height="150"
            style="background:#FFFFFF;color:#FFFFFF;margin:0 20px;text-align:center;"
            allowtransparency="true"
        ></iframe> -->
        <div class="safety-today" v-if="setNum == '2' && axiosTrue">
            <div class="list-today">
                <p>
                    <span class="fz16">今天</span>
                    <span class="fz16 f0B79F0">{{weatherList[0].weather | filterWeather}}</span>
                </p>
                <p>
                    <span class="fz20">{{weatherList[0].temp_low}}° ~ {{weatherList[0].temp_high}}°</span>
                    <span class="fz14" :style="weatherTodayAqi.styleBg">{{weatherTodayAqi.reAqi}}</span>
                </p>
            </div>
            <div class="list-today">
                <p>
                    <span class="fz16">明天</span>
                    <span class="fz16 f0B79F0">{{weatherList[1].weather | filterWeather}}</span>
                </p>
                <p>
                    <span class="fz20">{{weatherList[1].temp_low}}° ~ {{weatherList[1].temp_high}}°</span>
                    <span class="fz14" :style="weatherTomorrowAqi.styleBg">{{weatherTomorrowAqi.reAqi}}</span>
                </p>
            </div>
        </div>
        <div class="weather-warning" :class="setNum == '1' ? 'fz18' : 'fz16'" v-if="axiosTrue">
            <div v-if="weatherFutureHour.length > 0">
                {{ weatherFutureHour[0].dateYmdh | filterTodayNow }}~
                {{ weatherFutureHour[5].dateYmdh | filterTodayNow }}&nbsp;&nbsp;{{weatherFutureHour[5].wtNm}}
            </div>
        </div>
        <weatherLine :lineFuture="lineFuture" v-if="setNum == '2' && axiosTrue"></weatherLine>
    </div>
</template>
<script>
import weatherLine from "../productionSafetyCommon/weatherLine";
import axios from 'axios'

export default {
    name:'weatherSafety',
    data() {
        return {
            axiosTrue: true, // 天气预报有数据为true 没数据为false
            weatherList: [], // 一周天气预报的值
            weatherListHistory: [], // 历史一周天气预报的值
            weatherTodayAqi: '',  // 今天的aqi天气污染情况
            weatherTomorrowAqi: '',  // 今天的aqi天气污染情况
            lineFuture: {},  // 折线图所以使用的值
            weatherFutureHour: [],  // 折线图24小时天气  
            weatherAppkey: '',
            weatherSign: '',
            axiosIns: axios.create({})
        }
    },
    components: {
        weatherLine
    },
    props: {
        setNum: {
            type: String,
            required: true
        },
        weatherSlot: {
            type: String,
            required: true
        },
    },
    created(){
        this.getWeatherApi()
    },
    mounted () {
        this.getWeatherApi();
        this.weatherData1();
        this.weatherTimeData();

        // this.timer = setTimeout(() => {
        //     this.weatherData();
        //     this.weatherTimeData();
        // }, 1000 * 60 * 60 * 3);

        const nowTemp = new Date().getTime(); //获取当前时间戳
        const tomorrowTemp = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000); //获取今天24：00的时间戳
        const residueTemp = tomorrowTemp - nowTemp; //距离当天24：00的时间戳
        this.historyTimer = setTimeout(() => {
          setInterval(() => {
            //需要调用的方法
            this.weatherDataHistory();
          }, 1000*60*60*24);
        },residueTemp);
    },
    filters: {
        filterWeek(item,index){
            let _index = item.replace('星期','周');
            let _week = ''
            switch(index){
                case 0: 
                    _week = '今天';
                    break;
                case 1: 
                    _week = '明天';
                    break;
                default:
                    _week = _index;
            }
            return _week;
        },
        filterHistoryWeek(value){
            let _v = new Date(value.slice(0,4)+'-'+value.slice(4,6)+'-'+value.slice(6)).getDay()
            switch (_v) {
              case 0:
                return '周日'
              case 1:
                return '周一'
              case 2:
                return '周二'
              case 3:
                return '周三'
              case 4:
                return '周四'
              case 5:
                return '周五'
              case 6:
                return '周六'
            }
        },
        filterDays(value){
            let _days = value.replace(/-/g,'/');
            return _days.substr(5);
        },
        filterHistoryDays(value){
            return value.slice(4,6)+'/'+value.slice(6)
        },
        filterWeather(value){
            let _w = value.indexOf('转');
            let _val = value;
            if(_w > -1){
                _val = value.substr(0,_w);
            }
            return _val ;
        },
        filterWeather_icon(value){
            let _v = value
            _v = _v.replace('http://api.k780.com','https://sapi.k780.com')
            return _v
        },
        filterHistoryWeather_icon(value){
          let _v = value
          return `https://sapi.k780.com/upload/weather/d/${Number(_v)}.gif`
        },
        filterWind(value){
            let _wind = '';
            switch(value){
                case '0': 
                    _wind = '微风';
                    break;
                case '1': 
                    _wind = '东北风';
                    break;
                case '2': 
                    _wind = '东风';
                    break;
                case '3': 
                    _wind = '东南风';
                    break;
                case '4': 
                    _wind = '南风';
                    break;
                case '5': 
                    _wind = '西南风';
                    break;
                case '6': 
                    _wind = '西风';
                    break;
                case '7': 
                    _wind = '西北风';
                    break;
                case '8': 
                    _wind = '北风';
                    break;
            }
            return _wind;
        },
        filterWtWinpId(value){
            let wtWinpId = '';
            switch(value){
                case '0': 
                    wtWinpId = 3;
                    break;
                case '1': 
                    wtWinpId = 4;
                    break;
                case '2': 
                    wtWinpId = 5;
                    break;
                case '3': 
                    wtWinpId = 6;
                    break;
                case '4': 
                    wtWinpId = 7;
                    break;
                case '5': 
                    wtWinpId = 8;
                    break;
                case '6': 
                    wtWinpId = 9;
                    break;
                case '7': 
                    wtWinpId = 10;
                    break;
                case '8': 
                    wtWinpId = 11;
                    break;
                case '9': 
                    wtWinpId = 12;
                    break;
            }
            return wtWinpId;
        },
        filterTodayNow(value){
            let _v = value.substring(5,7) + '月' + value.substring(8,10) + '日' + value.substring(11,16);
            return _v
        },
    },
    methods:{
        getWeatherApi(){
            let _this = this;
            _this.$axios
                .get(`${window.pubilc_config.webserverurl}/api/video/video/GetWeatherForecast`)
                .then(resw=>{
                    if (resw.status == 200) {
                        _this.weatherAppkey = resw.data.Data.Appkey
                        _this.weatherSign = resw.data.Data.Sign
                        _this.weatherData1();
                        _this.weatherTimeData();
                    }
                }).catch(err=>{
                    console.log(err,'==/api/video/video/GetWeatherForecast')
                })
        },
        weatherFutureHourFun (){
            let _this = this;
            let _timeLine = _this.weatherFutureHour;
            let  _n = [],_time = [],_temp = [],_wind=[];
            let arr = {}
            _timeLine.forEach( (ele,index) => {
                if(index % 3 == 0){
                    let _w = this.$options.filters["filterWtWinpId"](ele.wtWinpId);
                    _temp.push(ele.wtTemp)  //温度
                    _wind.push(_w)  //风力
                    
                    _n.push(index)
                }
                
            })
            // console.log(_n,'当前的index',_wind,'当前的风力',_time,'当前的时间,_temp,'当前的温度')
            _time[0]="现在"; 
            arr.firstWtNm = _timeLine[0]
            arr.lastWtNm = _timeLine[_n[5]]
            arr.FutureHour = _time;
            arr.FutureTemp = _temp;
            arr.FutureWind = _wind;
            arr.weatherIcon = _timeLine[0].wtIcon;
            arr.weatherIcon5 = _timeLine[_n[5]].wtIcon; 
            this.lineFuture = arr;
        },
        weatherData1(){
          let _this = this;
          let weatherList = JSON.parse(window.sessionStorage.getItem('weatherListThisWeek'))
          let weatherListHistory = JSON.parse(window.sessionStorage.getItem('weatherListLastWeek'))
          if (weatherList) {
            _this.weatherList = weatherList;
          }else{
            _this.weatherData()
          }
          if (weatherListHistory) {
            _this.weatherListHistory = weatherListHistory;
          }else{
            _this.weatherDataHistory()
          }
        },
        weatherData (){ 
					// appkey=10003&sign=b59bc3ef6191eb9f747dd4e83c99f2a4
					let _this = this;
					_this.axiosIns
						.get(`${window.pubilc_config.weatherUrl}/?app=weather.future&weaId=1&&appkey=${_this.weatherAppkey}&sign=${_this.weatherSign}&format=json`)
						.then( res=> {
								// console.log(res,'七天天气预报')
								_this.axiosTrue = true;
								if(res.status == 200){
										_this.weatherList = res.data.result;
										window.sessionStorage.setItem('weatherListThisWeek',JSON.stringify(res.data.result))
								}else{
										_this.axiosTrue = false;
								}
						})
						.catch(err=>{
								_this.axiosTrue = false;
								console.log(err)
						}) 
        },
        weatherDataHistory(){
          let _this = this;
          let historyWetherSlot = []
          for (let i = 1; i <= 7; i++) {
            const ele = i;
            var date = new Date(new Date().getTime()-24 * 60 * 60 * 1000*ele);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            var d = date.getDate();
            m = m < 10 ? "0" + m : m; //月小于10，加0
            d = d < 10 ? "0" + d : d; //day小于10，加0
            let Today  = String(y) + String(m)  + String(d);
            historyWetherSlot.push(Today)
          }
          let firstDay = new Date().getFullYear() + '0101'  // 当年的0101
          let firstDayIndex = historyWetherSlot.indexOf(firstDay)   // 0101的index
          // firstDayIndex > -1 为跨年
					if(firstDayIndex > -1){
						let lastYearDay = historyWetherSlot.slice(0,firstDayIndex + 1)
						let nowYearDay = historyWetherSlot.slice(firstDayIndex + 1,historyWetherSlot.length)
						let lastTime = lastYearDay[lastYearDay.length-1] + '-' + lastYearDay[0]
						let nowTime = nowYearDay[nowYearDay.length-1] + '-' + nowYearDay[0]
						_this.weatherHistoryDiffYearAxios(lastTime,nowTime,historyWetherSlot)
					}else{
						let historyTime = historyWetherSlot[6]+'-'+historyWetherSlot[0] 
						_this.weatherHistoryAxios(historyTime,historyWetherSlot);
					}
        },
				weatherHistoryDiffYearAxios(lastTime,nowTime,historyWetherSlot){
					let _this = this;
					let lastData=[],nowData = [],concatData=[];
					_this.axiosIns
						.get(`${window.pubilc_config.weatherUrl}/?app=weather.history&weaId=1&dateYmd=${lastTime}&appkey=${_this.weatherAppkey}&sign=${_this.weatherSign}&format=json`)
						.then( res=> {
								if(res.status == 200){
									lastData = res.data.result.dtList;
									_this.axiosIns
										.get(`${window.pubilc_config.weatherUrl}/?app=weather.history&weaId=1&dateYmd=${nowTime}&appkey=${_this.weatherAppkey}&sign=${_this.weatherSign}&format=json`)
										.then( thisres=> {
												if(thisres.status == 200){
													nowData = thisres.data.result.dtList;
													concatData = lastData.concat(nowData);
													_this.weatherHistoryData(concatData,historyWetherSlot);

												}else{
													concatData=[]
												}
										})
										.catch(err=>{
											console.log(err)
										})
								}
						})
						.catch(err=>{
							console.log(err)
						})
        },
        weatherHistoryAxios(historyTime,historyWetherSlot){
					let _this = this;
					_this.axiosIns
						.get(`${window.pubilc_config.weatherUrl}/?app=weather.history&weaId=1&dateYmd=${historyTime}&appkey=${_this.weatherAppkey}&sign=${_this.weatherSign}&format=json`)
						.then( res=> {
								if(res.status == 200){
									let data = res.data.result.dtList;
									_this.weatherHistoryData(data,historyWetherSlot);
								}
						})
						.catch(err=>{
							console.log(err)
						})
        },
        weatherHistoryData(data,historyWetherSlot){
            let _this = this;
            let historyWether = []
            for (let index = 0; index < historyWetherSlot.length; index++) {
                const ele = historyWetherSlot[index];
                let weatherList_l1 = data.filter(item => {
                let time = item.upTime.split(' ')[0]
                    return time.split('-')[0]+time.split('-')[1]+time.split('-')[2] === ele
                })
                let weatherListTemp = []
                weatherList_l1.forEach(element => {
                weatherListTemp.push(Number(element.wtTemp))
                });
                let wtTempMin = Math.min(...weatherListTemp),
                    wtTempMax = Math.max(...weatherListTemp)
                let historyWeatherDetails = {
                    time:ele,
                    wtNm:weatherList_l1[10].wtNm, //天气描述
                    wtIcon:weatherList_l1[10].wtIcon, //天气图标
                    wtTempMax, //最高温度
                    wtTempMin, //最低温度
                    wtWinp:weatherList_l1[10].wtWinp, //风向
                    wtWindNm:weatherList_l1[10].wtWindNm, //风力
                }
                historyWether.unshift(historyWeatherDetails)
            }  
            _this.weatherListHistory = historyWether;
            window.sessionStorage.setItem('weatherListLastWeek',JSON.stringify(historyWether)) 
        },
        weatherTimeData (){
            let _this = this;
            let axiosUrl = `${window.pubilc_config.weatherUrl}/?app=weather.realtime&weaId=1&ag=today,futureDay,lifeIndex,futureHour&appkey=${_this.weatherAppkey}&sign=${_this.weatherSign}&format=json`
            _this.axiosIns
                .get(axiosUrl)
                .then( res=> {
                    if(res.status == 200){
                        _this.axiosTrue = true; 
                        let _data = res.data.result;
                        _this.weatherFutureHour = _data.futureHour
                        // console.log(_data,'详细天气预报')
                        let _listArr = []
                        _listArr.push(Object.assign(_data.realTime,_data.today))
                        
                        // console.log(_listArr)
                        _this.weatherTodayAqi = _this.filterAqi(_data.realTime.wtAqi);
                        _data.futureDay[0].wtBlueSkyId == "0" ?  _this.weatherTomorrowAqi = _this.filterAqi(170)  : _this.weatherTomorrowAqi = _this.filterAqi(49)
                        _this.weatherFutureHourFun();
                    }else{
                        _this.axiosTrue = false;
                    }
                })
                .catch(err=>{
                    _this.axiosTrue = false;
                    console.log(err)
                })
        },
        filterAqi(num){
            let numAqi  = num * 1;
            let re_Aqi = '',stylebg='',re_obj;
            switch(true){
                case (numAqi > 0 && numAqi <= 50) : 
                    re_Aqi = '优';
                    stylebg = "background-color:rgba(100,221,23,0.72)";
                    break;
                case (numAqi > 50 && numAqi <= 100) : 
                    re_Aqi = '良';
                    stylebg = "background-color:rgba(87,211,23,0.72)";
                    break;
                case (numAqi > 100 && numAqi <= 150) : 
                    re_Aqi = '轻度';
                    stylebg = "background-color:rgba(129,212,250,0.72)";
                    break;
                case (numAqi > 150 && numAqi <= 200) : 
                    re_Aqi = '中度';
                    stylebg = "background-color:rgba(241,196,15,0.72)";
                    break;
                case (numAqi > 200 && numAqi <= 300) : 
                    re_Aqi = '重度';
                    stylebg = "background-color:rgba(230,127,34,0.72)";
                    break;
                case (numAqi > 300) : 
                    re_Aqi = '严重';
                    stylebg = "background-color:rgba(228,40,40,0.72)";
                    break;
                default: 
                    re_Aqi = '-'
                    stylebg = "background-color:rgba(100,221,23,0.72)";
                    break;
            }
            re_obj = {
                reAqi: re_Aqi,
                styleBg: stylebg
            }
            return re_obj;
        },
        
    },
    beforeDestroy: function() {
        if (this.timer) {
          clearInterval(this.timer);
        }
        if (this.historyTimer) {
          clearInterval(this.historyTimer);
        }
    }

}
</script>
<style lang="scss" scoped>
.weather-wampper{
    .fz16{
        font-size:16px;
    }
    .fz18{
        font-size:18px; 
        line-height: 42px;
    }
    .fz20{
        font-size: 20px;
    }
    .fz14{
        font-size: 14px;
        font-family: AlibabaPuHuiTi;
        line-height: 22px;
        padding: 0 6px;
        text-align: center;
        min-width: 40px;
    }
    
    .bgcolorF46A0D{
        background: rgba(244, 106, 13, 0.72);
    }
    .bgcolor4CAF50{
        background: rgba(76, 175, 80, 0.72);
    }
    width: 100%;
    .day-list{
        height: 232px;
        display: flex;
        overflow-y: scroll;
        .day-child{
            flex: 1;
            justify-content: space-between;
            text-align: center;
            background: rgba(255, 255, 255, 0.05);
            color: rgba(255, 255, 255, 0.5);
            margin-right: 5px;
            // padding: 10px 0;
            font-size:12px;
            .bgIcon-weather{
                display: inline-block;
                width: 40px;
                height: 30px;

            }
            .list-weather{
                height: 27px;
                margin-bottom: 30px;
                img{
                    margin-top: 6px;
                }
            }
            .list-date{
                padding-top: 10px;
                padding-bottom: 12px;
            }
            .list-T{
                padding-bottom: 19px;
            }
            .list-wind{
                padding-bottom: 10px;
            }
        }
        .day-child:last-child{
            margin: 0;
        }

    }
    .safety-today{
        display: flex;
        margin-bottom: 20px;
        .list-today{
            flex:1;
            justify-content: space-between;
            text-align: center;
            background: rgba(255, 255, 255, 0.05);
            color: rgba(255, 255, 255, 0.5);
            padding:14px 16px;
            p{
                line-height:36px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                color:#FFFFFF;
            }
        }
        .list-today:first-child{
            margin-right: 20px;
        }
    }
    .weather-warning{
        line-height: 32px;
        background: rgba(255, 178, 36, 0.6);
        border-radius: 1px;
        text-align: center;
        font-family: AlibabaPuHuiTi;
        font-weight: 400;
        color: #FFFFFF;
    }
}
</style>